<template>
  <input class="editable-title"
         :class="{'cursor-not-allowed': disabled}"
         :disabled="disabled"
         @click.stop="edit"
         @blur="updateTitle"
         :value="value"
         :ref="(input)=> this.input = input"
  />
</template>

<script>

export default {
    name: 'EditableTitle',
    props:{
        value: {type: String, required: true},
        editing: {type: Boolean, required: true},
        disabled: {type: Boolean},
    },
    data() {
        return {
            newValue: null,
        }
    },
    methods: {
        edit () {
            this.$emit('update:editing', true);
            this.$emit('emitClick');
        },
        updateTitle($event) {
            this.newValue = $event.currentTarget.value;
            if(this.newValue !== '') {
                if(this.newValue !== this.value) {
                    this.$emit('updateTitle', this.newValue);
                }
            } else {
                $event.currentTarget.value = this.value;
            }
 
            this.$emit('update:editing', false);
        },
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .editable-title {
        border: 2px solid transparent;
        padding: 0;
        margin: 0;
        font-size: 16px;
        border-radius: 2px;
        padding: 2px 4px;
        padding-left: 0;
        transition: all .2s linear;
        text-overflow: ellipsis;
        background: transparent;
        flex: 1;
        &:hover {
            background-color: #DCDCDC;
        }
        &:focus {
            outline: none;
            border: 2px solid #286ED7;
            text-overflow: initial;
            &:hover {
                background-color: #ffffff;
            }
        }
        
    }
</style>
